export const BOT_SCORE_COOKIE_NAME = 'X-NW-sig_lvl';
export const IS_BOT_COOKIE_NAME = 'X-NW-bt';
export const IS_VERIFIED_BOT_COOKIE_NAME = 'X-NW-f_opt';
export const ANONYMOUS_ID_COOKIE_NAME = 'ajs_anonymous_id';
export const WORDPRESS_ACTIVE_SESSION_COOKIE = 'wordpress_session_active';
export const WORDPRESS_ACTIVE_SESSION_PREFIX = 'wordpress_logged_in_';
